/**
 * Created by elad on 15 נובמבר 2016.
 */
import VueRouter from "vue-router";
import middleware from "src/middleware";
import LoginView from "./views/auth/LoginView";
import Dashboard from "./layout/Dashboard";
import WelcomeView from "./views/WelcomeView";
import UsersView from "./views/users/UsersView";
// import UserProfile from './views/dashboard/pages/UserProfile'
import RegisterView from "./views/auth/RegisterView";
import LotteriesView from "./views/lotteries/LotteriesView";
import ClientsView from "./views/clients/ClientsView";
import CardsView from "./views/cards/CardsView";
import LotteryIframe from "./views/system/LotteryIframe";

const routes = [

    {path: "/", component: WelcomeView, name: "home-page"},
    {path: "/lottery/:lotteryId", component: WelcomeView, name: "welcome-page"},
    {path: "/admin/login", component: LoginView, name: "login-page"},
    // {path: '/register', component: RegisterView, name: 'register-page'},
    {
        path: "/dashboard",
        component: Dashboard,
        meta: {RequireAuth: true},
        children: [
            {
                name: "main-dashboard",
                path: "",
                redirect: {name: "clients-view"}
            }, {
                name: "users-view",
                path: "users",
                component: UsersView,
            }, {
                name: "lottery-view",
                path: "lottery",
                component: LotteriesView,
            },
            {
                name: "clients-view",
                path: "clients",
                component: ClientsView,
            },
            {
                name: "cards-view",
                path: "cards",
                component: CardsView,
            },
            {
                name: "lottery-iframe",
                path: "mainlottery",
                component: LotteryIframe,
            }
        ],
    },
];

const router = new VueRouter({
    history: false,
    mode: "history",
    routes,
});

router.beforeEach((to, from, next) => {
    middleware.check(to, from, next);
});

export default router;
